import { createFileRoute } from "@tanstack/react-router";
import { LoginPage } from "../../features/auth/components/LoginPage";

export const Route = createFileRoute("/auth/login")({
  validateSearch: (search: Record<string, unknown>) => ({
    redirect: search.redirect as string | undefined,
  }),
  component: LoginPage,
});
